<template>
  <div class="py-3">
    <div v-if="title" class="mb-2 flex items-baseline">
      <p
        :class="
          cn('ui-text-xs font-medium mr-1.5 uppercase text-white', labelClass)
        "
      >
        {{ title }}:
      </p>
    </div>
    <div class="flex flex-wrap gap-2" :class="cn(gridSizeClasses)">
      <button
        v-for="item in block.materials"
        :key="item.id"
        class="group relative min-w-10 min-h-10 flex p-2 items-center justify-center gap-1 border border-black-60 text-white ui-text-xs"
        :class="{
          'border !border-white bg-black-80 !font-medium':
            selectedItem?.id === item.id,
        }"
        :disabled="item.disabled"
        @click="onFilterClick(block.slug, item)"
      >
        {{ item?.currentTranslation?.title }}
      </button>
    </div>
    <SharedFieldHint :message="errorMessage" error />
    <slot name="additional" />
  </div>
</template>

<script setup lang="ts">
import { useField } from "vee-validate";
import {
  IProductMaterialFilterEvent,
  IProductMaterialFilterProps,
  MaterialData,
} from "ecom-types";
import { propertiesGroupSlugs } from "~/configs";

const props = defineProps<IProductMaterialFilterProps>();

const emit = defineEmits<{
  (e: "filter", value: IProductMaterialFilterEvent): void;
}>();

const { errorMessage, setValue } = useField(props.block?.slug, undefined, {
  initialValue: props.selectedItem?.sku,
});

const gridSizeClasses = computed(() => {
  if (props.block.view_type === filterViewType.button_big) {
    return "grid-cols-3 lg:grid-cols-[repeat(auto-fit,minmax(100px,auto))]";
  } else {
    return "grid-cols-5 lg:grid-cols-[repeat(auto-fill,minmax(64px,auto))]";
  }
});

function onFilterClick(slug: string, item: MaterialData) {
  setValue(item.sku);
  emit("filter", { slug, item });
}
</script>
